import { createSlice } from "@reduxjs/toolkit"

const initialState={
    selectedEntities: []

}

const entitySlice=createSlice({
    initialState,
    name:"entity",
    reducers: {
        setSelectedEntities: (state, action) => {
          state.selectedEntities = action.payload // replace entire array
        },
        addSelectedEntity: (state, action) => {
          if (!state.selectedEntities.find(e => e.id === action.payload.id)) {
            state.selectedEntities.push(action.payload)
          }
        },
        removeSelectedEntity: (state, action) => {
          state.selectedEntities = state.selectedEntities.filter(
            entity => entity.id !== action.payload
          )
        },
        clearSelectedEntities: (state) => {
          state.selectedEntities = []
        }
      }
    })
    
    export const {
      setSelectedEntities,
      addSelectedEntity,
      removeSelectedEntity,
      clearSelectedEntities
    } = entitySlice.actions
    
    export default entitySlice.reducer